import { render, staticRenderFns } from "./ScrollPane.vue?vue&type=template&id=62c2558c&scoped=true"
import script from "./ScrollPane.vue?vue&type=script&lang=js"
export * from "./ScrollPane.vue?vue&type=script&lang=js"
import style0 from "./ScrollPane.vue?vue&type=style&index=0&id=62c2558c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c2558c",
  null
  
)

export default component.exports